import { Meteor } from 'meteor/meteor';
import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { strings } from '/imports/strings';
import { Doc, FileMeta, GetMethodResponse, ListMethodArg, ListMethodResponse, ModelClass, References } from '/imports/types';
import { validateString } from '/imports/validators';

export interface SupportTicketMessage extends Doc {
  _id: string;
  supportTicketId: string;
  content: string;
  files?: FileMeta[];
}
export type Model = SupportTicketMessage;

export const SupportTicketMessages = new Mongo.Collection<SupportTicketMessage>('supportTicketMessages');

type Refs = References<Model>

export const modelClass: ModelClass<Model, Refs> = {
  collection: SupportTicketMessages,
  editableFields: [
    'supportTicketId', 'content', 'files',
  ],
  listMethod: DeclareMethod<ListMethodArg<SupportTicketMessage>, ListMethodResponse<SupportTicketMessage, Refs>>('listSupportTicketMessages'),
  getMethod: DeclareMethod<string, GetMethodResponse<SupportTicketMessage, Refs>>('getSupportTicketMessage'),
  createMethod: DeclareMethod<Partial<SupportTicketMessage>, string>('createSupportTicketMessage'),
  updateMethod: DeclareMethod<Partial<SupportTicketMessage>, string>('updateSupportTicketMessage'),
  deleteMethod: DeclareMethod<string>('deleteSupportTicketMessage'),
  pathPrefix: '/support',
  asString: (document) => document.caseNumber,
  modelName: strings.SupportTicket(),
  pluralName: strings.SupportTickets(),
  searchQuery: (search?: string) => {
    search = search?.trim();
    if (!search?.length) return {};
    return {
      $or: [
        { _id: search },
        { content: new RegExp(search, 'gi') },
      ]
    };
  },
  validate: async (set: Partial<SupportTicketMessage>) => {
    const errors: { [key: string]: string[] } = {};
    validateString(errors, set, 'supportTicketId', { required: true });
    validateString(errors, set, 'content', { required: true });
    return errors;
  },
};

Meteor.isServer && Meteor.startup(async () => {
  await SupportTicketMessages.createIndexAsync({ supportTicketId: 1 });
  await SupportTicketMessages.createIndexAsync({ content: 1 });
});
